/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Read_Only_Description_Private_ChatsInputs */



/**
* | output |
* | --- |
* | "You can read this project's files, but not start a chat here. Chats in this project are private, so other members' chats, their attached files and AI-created..." |
*
* @param {Project_Read_Only_Description_Private_ChatsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_read_only_description_private_chats = /** @type {((inputs?: Project_Read_Only_Description_Private_ChatsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Read_Only_Description_Private_ChatsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie können die Dateien dieses Projekts lesen, aber hier keinen Chat starten. Die Chats in diesem Projekt sind privat, daher sehen Sie die Chats anderer Mitglieder samt angehängten Dateien und KI-erstellten Dokumenten nicht.")
	return /** @type {LocalizedString} */ ("You can read this project's files, but not start a chat here. Chats in this project are private, so other members' chats, their attached files and AI-created documents are not visible to you.")
});